import React from 'react'
import {
  ChakraProvider,
  Box,
  Image,
  Center,
  Text,
  Flex,
  Link,
  Button,
} from '@chakra-ui/react'

const About = () => {
  return (
    <ChakraProvider>
      <Box
        w={{
          base: '90%',
          sm: '90%',
          md: '90%',
          lg: '90%',
          xl: '90%',
        }}
        alignContent='center'
        mx='auto'
        h={{
          base: 'auto',
          sm: 'auto',
          md: 'auto',
          lg: 'auto',
          xl: 'auto',
        }}>
        <Center>
          <Text
            fontSize={{
              base: '30px',
              sm: '30px',
              md: '35px',
              lg: '35px',
              xl: '35px',
            }}
            fontFamily='Inter'
            letterSpacing='5px'
            my={{ base: '30px', md: '50px' }}>
            {' '}
            About
          </Text>
        </Center>
        <Flex
          direction={{
            base: 'column',
            sm: 'column',
            md: 'row',
            lg: 'row',
            xl: 'row',
          }}
          gap='10px'
          w='auto'>
          <Box
            w={{
              base: '100%',
              sm: '100%',
              md: '50%',
              lg: '50%',
              xl: '50%',
            }}>
            <Image
              src='/avatar.jpg'
              objectFit='contain'
              h='500px'
              w='100%'
              maxW='100%'
            />
          </Box>
          <Box
            w={{
              base: '100%',
              sm: '100%',
              md: '50%',
              lg: '50%',
              xl: '50%',
            }}>
            <Text
              as='p'
              fontSize='17px'
              fontFamily='Roboto mono'
              letterSpacing='5px'>
              Hello there, my name is Caleb, my buddies call me Bintus, i'm a
              frontend developer from West Africa, i bagged a Degree in Building
              Technoogy.
              <br />
              <br />I am a self taught MERN stack developer, i started my career
              in tech as a front end developer, i later advanced to use Reactjs
              in frontend development in 2021, i went on to learn Nextjs. Later
              in the year 2022 i made a switch to backend by learning Express
              js. In my free time, i enjoy playing and watching football
              (soccer), i enjoy watching movies and tv series and japanese
              animes, most importantly, i am a fan of literally every genre of
              music, but yeah my favorite definitely is trap music!
            </Text>
            <br />
            <br />
            <Button
              color='White'
              _hover={{ color: 'olive', bg: '#FAF0E6' }}
              bg='Olive'
              className='button'
              variant='solid'
              mx={{
                base: '15%',
                sm: '15%',
                md: '30%',
                lg: '30%',
                xl: '20%',
              }}
              p='30px'
              w='250px'>
              <a href='https://docs.google.com/document/d/1TzjvXDG4MZiZj_eAdRvXBJlPQbgtjY97t88Vw0HIrKo/edit?usp=sharing'>
                <i className='fa-regular fa-file'></i> View my resume
              </a>
            </Button>
          </Box>
        </Flex>
      </Box>
    </ChakraProvider>
  )
}

export default About
